export const onFormChange = ({ userStore }) => (value, [name]) => {
  userStore.setField(name, value[name])
}
